import type { ICommand } from './ICommand';
import type { IComparable } from './IComparable';
import { compare } from './util';

interface ICreateUndoableRepository<T> {
  save(value: T): Promise<void>;
  delete(): Promise<void>;
  get(): Promise<T | null>;
}

export class CreateCommand<T extends IComparable<T> | boolean | number | string> implements ICommand {
  constructor(
    private readonly value: T,
    private readonly repository: ICreateUndoableRepository<T>
  ) {}

  do(): void {
    const { value, repository } = this;

    repository.save(value).then();
  }

  undo(): void {
    this.repository.delete().then();
  }

  redo(): void {
    this.do();
  }

  async canUndo(): Promise<boolean> {
    const { value, repository } = this;

    const currentValue = await repository.get();
    if (currentValue === null) return false;

    return compare(currentValue, value);
  }

  async canRedo(): Promise<boolean> {
    const currentValue = await this.repository.get();
    return currentValue === null;
  }
}
